import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
  } from '@angular/core';
import { NecModalService } from './modal.service';


@Component({
  moduleId: module.id.toString(),
  selector: 'nec-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class NecModalComponent implements OnInit, OnDestroy {

  @Input() title = '';

  @Input() id: string;

  @Output() openClick: EventEmitter<void> = new EventEmitter<void>();

  @Output() closeClick: EventEmitter<void> = new EventEmitter<void>();

  display: boolean;

  element: any;

  constructor(
    private modalService: NecModalService,
    private el: ElementRef
  ) {
    this.display = false;
    this.element = el.nativeElement;
  }

  ngOnInit() {
    let modal = this;
    if (!modal.id) {
      return;
    }
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  open() {
    this.ngOnInit();
    this.display = true;
    this.openClick.emit();
  }

  close() {
    this.closeClick.emit();
    this.display = false;
    document.body.classList.remove('modal-open');
  }

}
